"use client";

import { useEffect, useState } from "react";
import {
  readMatterportRuntimeMetadata,
  subscribeMatterportFeatures,
  type MatterportCapabilitiesSdk,
  type MatterportFeatures,
} from "@/lib/virtualspace/matterport-sdk-capabilities";

const UNKNOWN: MatterportFeatures = { splatPresent: undefined, meshPresent: undefined };

export function useMatterportRuntime(sdk: MatterportCapabilitiesSdk | null) {
  const [snapshot, setSnapshot] = useState<{ sdk: MatterportCapabilitiesSdk; features: MatterportFeatures } | null>(null);
  useEffect(() => {
    if (!sdk) return;
    return subscribeMatterportFeatures(sdk, (features) => setSnapshot({ sdk, features }));
  }, [sdk]);
  return {
    features: snapshot?.sdk === sdk ? snapshot.features : UNKNOWN,
    metadata: sdk ? readMatterportRuntimeMetadata(sdk) : null,
  };
}
